/**
 * root.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Import all the third party stuff
import * as ReactDOM from "react-dom/client";

import { Provider, App as AntdApp } from "react-redux";
// import FontFaceObserver from 'fontfaceobserver';
import { ConfigProvider, notification } from "antd";
import "sanitize.css/sanitize.css";
import "theme/custom.css";
import "antd/dist/reset.css";

import frFR from "antd/locale/fr_FR";

import "dayjs/locale/fr-ch";
import "./utils/prototypeOverride";

import App from "./engine/App";

// Load the favicon and the .htaccess file
import "!file-loader?name=[name].[ext]!public/favicon.ico";
import "file-loader?name=.htaccess!public/.htaccess"; // eslint-disable-line import/extensions
// root
import { storeNew } from "store/store.new";

import "engine/i18n";
import AppProviders from "./engine/context/AppProviders";
import { LoadingIndex } from "./shared/components/LoadingIndex";
import { ModalsDynamic } from "./shared/components/Modals/ModalsDynamic";

const root = ReactDOM.createRoot(document.getElementById("app"));

export const colorPrimary = "#F93B3D";
const root_theme = document.querySelector(":root");

// Set default notification duration (in seconds)
notification.config({
  duration: 5, // Default duration of 5 seconds
});

root_theme.style.setProperty("--color-primary", colorPrimary);

root.render(
  <AppProviders>
    <Provider store={storeNew}>
      <ConfigProvider
        locale={frFR}
        theme={{
          token: {
            borderRadius: 2,
            colorBorder: "#a79e9e",
            controlHeight: 40,
            colorPrimary: colorPrimary,
            colorTextSecondary: "#262626",
            colorTextBase: "#262626",
            colorText: "#565556",
            colorTextHeading: "#262626",
            colorTextLabel: "#000000",
            //colorBgContainer: '#F8F8F8',
            colorBgLayout: "#F8F8F8",
            colorLink: "#F93B3D",
            colorLinkHover: "#fd7172",
            linkHoverDecoration: "underline",
          },
        }}
      >
        <LoadingIndex>
          <App />
          <ModalsDynamic />
        </LoadingIndex>
      </ConfigProvider>
    </Provider>
  </AppProviders>,
);

// if (process.env.NODE_ENV !== 'production' && module.hot) {
//   // Hot reloadable React components and translation json files
//   // modules.hot.accept does not accept dynamic dependencies,
//   // have to be constants at compile-time
//   module.hot.accept(['./engine/App'], () => {
//     const NextRootContainer = require('./engine/App').default;
//     //root.unmountComponentAtNode(document.getElementById('app'));
//     render(NextRootContainer);
//   });
// }
